import React from "react";

// Drawn to match the other tab icons in SurveyDataDashboard/Icons — same 1.14
// stroke on #5770CB, no fill.
const SparkleIcon = ({ size = 16 }) => (
   <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M6.4 1.6L7.52 4.62L10.53 5.73L7.52 6.85L6.4 9.87L5.28 6.85L2.27 5.73L5.28 4.62L6.4 1.6Z"
         stroke="#5770CB"
         strokeWidth="1.14286"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path
         d="M12 8.53L12.62 10.18L14.27 10.8L12.62 11.42L12 13.07L11.38 11.42L9.73 10.8L11.38 10.18L12 8.53Z"
         stroke="#5770CB"
         strokeWidth="1.14286"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);

export default SparkleIcon;
